import { Link } from "@/components/site/LocaleLink";
import { ArrowRight } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { getFeatured } from "@/data/products";
import { Reveal, RevealGroup, RevealItem } from "@/components/site/Reveal";
import { ProductCard } from "@/components/site/ProductCard";

export const FeaturedProducts = () => {
  const { t } = useLang();
  const featured = getFeatured();
  return (
    <section className="bg-mint py-24 lg:py-32" data-testid="featured-products">
      <div className="container-x">
        <div className="mb-14 flex flex-col items-start justify-between gap-6 sm:flex-row sm:items-end">
          <div className="max-w-2xl">
            <Reveal>
              <p className="eyebrow mb-4 text-gold-ink">{t.featured.kicker}</p>
            </Reveal>
            <Reveal i={1}>
              <h2 className="font-display text-4xl font-extrabold leading-tight tracking-tight text-forest sm:text-5xl">
                {t.featured.title}
              </h2>
            </Reveal>
          </div>
          <Reveal i={2}>
            <Link
              to="/products"
              data-testid="featured-view-all"
              className="group inline-flex items-center gap-2 rounded-full border border-forest/30 px-6 py-3 text-sm font-semibold text-forest transition-colors duration-300 hover:bg-forest hover:text-cream"
            >
              {t.nav.browse}
              <ArrowRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-1 rtl-flip" />
            </Link>
          </Reveal>
        </div>

        <RevealGroup className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3">
          {featured.map((p, i) => (
            <RevealItem key={p.slug}>
              <ProductCard product={p} index={i} />
            </RevealItem>
          ))}
        </RevealGroup>
      </div>
    </section>
  );
};
